import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  notifications: {
    alignItems: 'center',
    backgroundColor: Colors.vfRed,
    borderRadius: 20 / 2,
    height: 20,
    justifyContent: 'center',
    position: 'absolute',
    top: -5,
  },
  notificationsText: {
    color: Colors.white,
    fontFamily: Fonts.type.bold.fontFamily,
    fontSize: 12.5,
    fontWeight: Fonts.type.bold.fontWeight,
    letterSpacing: 0,
    lineHeight: 13,
    textAlign: 'center',
  },
});
